module.exports = __webpack_public_path__ + "media/img/home/clients-map/sw-2ec5981991f5a33b2af2d07a5d14a596.png";